export default __webpack_public_path__ + "static/media/1100904紫克科技網站_可視化管理看板（一）.76e6fce1.png";